import axios from 'axios';
import { useCallback, useState } from 'react';

interface UseUploadImageReturn {
  uploadImage: (file: File, presignedUrl: string) => Promise<string | undefined>;
  loading: boolean;
  error: string | undefined;
}

export const useUploadImage = (): UseUploadImageReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const uploadImage = useCallback(async (file: File, presignedUrl: string) => {
    setLoading(true);
    setError(undefined);

    try {
      const response = await axios.put(presignedUrl, file, {
        headers: {
          'Content-Type': file.type
        }
      });

      if (response.status !== 200) {
        throw new Error('Failed to upload the image');
      }

      // Quita los parámetros de la URL
      const cleanUrl = response.config.url?.split('?')[0] ?? '';

      return cleanUrl;
    } catch (error_: unknown) {
      console.error('Error uploading image:', error_);
      setError('Failed to upload image');

      return undefined;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    uploadImage,
    loading,
    error
  };
};
